export default {"src":"/_next/static/media/envelope-solid.f942d9d2.svg","height":13,"width":17};